export const DEFAULT_SUGGESTED_BAND = '12';
